import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	objectCreatedLabel: {
		id: 'servicedesk-insight-object-view.object-dates.object-created-label',
		defaultMessage: 'Created {date}',
		description:
			'Label indicating when the current object was created. The rendered date will be formatted using the users locale.',
	},
	objectModifiedLabel: {
		id: 'servicedesk-insight-object-view.object-dates.object-modified-label',
		defaultMessage: 'Modified {date}',
		description:
			'Label indicating when the current object was last modified. The rendered date will be formatted using the users locale.',
	},
});
